import { Tables } from "@/lib/supabase/supabase_types_override";
import { QuestionFieldOptions } from "@/features/question/types/fieldOptions";

export const extractFieldProperties = <
  T extends Pick<Tables<"question">, keyof QuestionFieldOptions> = Pick<Tables<"question">, keyof QuestionFieldOptions>
>(
  question: T
) => {
  const {
    field_options,
    field_date_options,
    field_default_value,
    field_label,
    field_max_label,
    field_min_label,
    field_decimal_places,
    field_integer_places,
    field_step,
    field_min,
    field_max,
    field_placeholder,
  } = question;
  return {
    field_options,
    field_date_options,
    field_default_value,
    field_label,
    field_max_label,
    field_min_label,
    field_decimal_places,
    field_integer_places,
    field_step,
    field_min,
    field_max,
    field_placeholder,
  };
};